import { PdpIntroductionDTO } from '@/types/models';
import { client } from '@/api/client';
export const getPdpIntroduction = async (id: string): Promise<PdpIntroductionDTO & {
  id: string;
}> => {
  try {
    const result = await client.get(`/plans/${id}}/info`);
    return {
      ...result.data.data,
      id
    };
  } catch (error) {
    return {} as PdpIntroductionDTO & {
      id: string;
    };
  }
};
export const pdpIntroductionOptions = (id: string) => {
  return {
    queryKey: ['pdp-introduction', id],
    queryFn: () => getPdpIntroduction(id)
  };
};